import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { getModuleEnum, getAccessLevelByModule, getPOSSessionActiveStatus } from '../../../server/util';
import { CATERER_WEB_URL, access_token } from '../../../server/constants';
let loginUserInfo = {}
class QuickBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripeInfo: {}
    }

  }
  componentDidMount = () => {
    loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
    let _stripeInfo = { 'isPaymentEnabled': loginUserInfo.isPaymentEnabled, 'stripeAccountId': loginUserInfo.stripeAccountId };
    this.setState({ stripeInfo: _stripeInfo })
  }
  prepareCatererUrl = () => {
    const refresh_token = sessionStorage.getItem('refresh_token') || '';
    const schoolId = sessionStorage.getItem('SchoolId');
    const _src = `${btoa(`akey=${access_token()}&rkey=${refresh_token}&sid=${schoolId}`)}`;

    return `${CATERER_WEB_URL}/?${_src}`
  }
  render() {
    loginUserInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
    const modEnum = getModuleEnum();
    return (
      <div className="sidebar-menu hidden-sm hidden-xs hidden-md">

        <div className="menu">
          <ul id="menu">
            {getAccessLevelByModule(modEnum.SIU) || getAccessLevelByModule(modEnum.SM) || getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.SSISI) ?
              <li className='bg-color-1'><a href="#"><i className="fa fa-users"></i></a>
                <ul>
                  {(getAccessLevelByModule(modEnum.SIU) || getAccessLevelByModule(modEnum.SSISI)) ?
                    <li className='bg-color-1'><Link to="/schoolAdmin/setupSchool" >Import Students</Link></li> : null}
                  {getAccessLevelByModule(modEnum.SM) ? <Fragment>
                    <li className='bg-color-1'><Link to="/schoolAdmin/manageSchool" >Manage Students</Link></li>
                    <li className='bg-color-1'><Link to="/schoolAdmin/studentLookUp" >Student Lookup</Link></li>
                  </Fragment> : null}
                </ul>
              </li> : null}
            {
              getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.MPAE) || getAccessLevelByModule(modEnum.ESEA) ?
                <ul>
                  <li className='bg-color-6'><a href="#"><i className="fa fa-file-text"></i></a>
                    <ul>
                      <li className='bg-color-6'><Link to="/schoolAdmin/schoolMealProgram" >Manage Application</Link></li>
                      <li className="bg-color-6"><Link to="/schoolAdmin/importCertificationData">Direct Certification Import</Link>
                      </li>
                      {
                        getAccessLevelByModule(modEnum.ESEA) ?
                          <li><Link to="/schoolAdmin/eseaFormList">ESEA Form</Link></li> : null
                      }
                    </ul>
                  </li>

                </ul> : null

            }
            {
              getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCI) ||
                getAccessLevelByModule(modEnum.BMCU) || getAccessLevelByModule(modEnum.BMCI) ?
                <li className='bg-color-2'><a href="#"><i className="fa fa-cutlery"></i></a>
                  <ul>
                    {/* {
                            getAccessLevelByModule(modEnum.LMCU)|| getAccessLevelByModule(modEnum.BMCU) ?
                            <li className='bg-color-2'><Link to="/schoolAdmin/createMenu"> Create Menu</Link></li>:null}
                         */}
                    {
                      (sessionStorage.getItem('ROLE') == 'ROLE_ADMIN') ? null : <li className=""><Link to="/schoolAdmin/createMenu">Create Menu</Link></li>
                    }
                    {
                      getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCU) ?
                        <li className='bg-color-2'><Link to="/schoolAdmin/viewMenu" > View Menu</Link></li> : null
                    }
                    {
                      getAccessLevelByModule(modEnum.LMCU) || getAccessLevelByModule(modEnum.LMCU) ?
                        <li className="bg-color-2"><Link to="/schoolAdmin/menuManage">Menu Management</Link></li> : null
                    }
                    <li className='bg-color-2'><Link to="/schoolAdmin/lunchSessions" > Lunch Session</Link></li>
                    <li className="bg-color-2"><a href={this.prepareCatererUrl()} target="_blank">Go To Caterer Dashboard</a></li>

                  </ul>
                </li> : null}
            <li className='bg-color-3'><a href="#"><i className="fa fa-file-text"></i></a>
              <ul>

                <li className='bg-color-3'><Link to="/schoolAdmin/viewOrdersGrid" > View/Manage Orders</Link></li>
                {/* <li className='bg-color-3'><Link to="/schoolAdmin/bulkOrdersGrid" > Bulk Orders</Link></li> */}
              </ul>
            </li>
            <li className='bg-color-8'><a href="#"><i className="fa fa-bar-chart"></i></a>
              <ul>
                <li className="bg-color-3"><Link to="/schoolAdmin/viewReports">Quick Reports</Link></li>
                <li className='bg-color-3'><Link to="/schoolAdmin/mealReport" > Meal Reports</Link></li>
                <li className='bg-color-3'><Link to={{
                  pathname: '/schoolAdmin/financialReport',
                  state: { stripeReport: this.state.stripeInfo }
                }} > Financial Reports</Link></li>
                {(getAccessLevelByModule(modEnum.LETM) || getAccessLevelByModule(modEnum.CEPS)) && <li className='bg-color-3'><Link to="/schoolAdmin/claimReport">Claims Reports</Link></li>}
              </ul>
            </li>
            {
              getAccessLevelByModule(modEnum.APCC) || getAccessLevelByModule(modEnum.APO) ?
                <li className='bg-color-4'><a href="#"><i className="fa fa-credit-card"></i></a>
                  <ul>
                    {getAccessLevelByModule(modEnum.APCC) ? <Fragment>
                      <li className='bg-color-4'><Link to="/schoolAdmin/managePayments" > Add Payments</Link></li>
                      <li className='bg-color-4'><Link to="/schoolAdmin/manageLunchBalance">Import/Export Account Balance</Link></li>
                    </Fragment> : null
                    }
                    <li className='bg-color-4'><Link to="/schoolAdmin/addTransaction"> Add Transaction</Link></li>
                    {getAccessLevelByModule(modEnum.CEPS) && <li className="bg-color-4"><Link to="/schoolAdmin/bulkTransaction">Bulk Transactions</Link></li>}
                    {getPOSSessionActiveStatus() && <li className="bg-color-4"><Link to="/schoolAdmin/dailyPosCash">Daily POS Cash Approval</Link></li>}
                  </ul>
                </li>
                : null
            }
            {getAccessLevelByModule(modEnum.MPAE) || getAccessLevelByModule(modEnum.BACP) ?

              <li className='bg-color-6'><a href="#"><i className="fa fa-child"></i></a>
                <ul>

                  {
                    getAccessLevelByModule(modEnum.MPAE) ?
                      <li className='bg-color-6'><Link to="/schoolAdmin/events" >Manage Events</Link></li> : null}
                  {
                    getAccessLevelByModule(modEnum.BACP) ?
                      <li className='bg-color-6'><Link to="/schoolAdmin/manageBcAc" >Manage BC & AC</Link></li> : null}
                </ul>
              </li> : null
            }

            <li className='bg-color-5'><a href="#"><i className="fa fa-user-secret"></i></a>
              <ul>
                <li className='bg-color-5'><Link to="/schoolAdmin/account" > Account Details</Link></li>
                <li className='bg-color-5'><Link to={{
                  pathname: '/schoolAdmin/account/changePassword'
                }}> Change Password</Link></li>
              </ul>
            </li>

            {loginUserInfo.isPrimaryAdmin ? (
              <li className="bg-color-6">
                <a href="#"><i className="fa fa fa-cogs"></i></a>
                <ul>
                  {
                    getAccessLevelByModule(modEnum.SSISI) ?
                      <li className='bg-color-6'><Link to="/schoolAdmin/datasync"> Data Sync Settings </Link></li> : null}
                  <li className='bg-color-6'><Link to="/schoolAdmin/manageUsers">  Manage Users
                  </Link></li>
                  <li className='bg-color-6'><Link to="/schoolAdmin/lowBalEmail">  Low Balance Email Setup
                  </Link></li>
                  <li className='bg-color-6'><Link to="/schoolAdmin/manageSchools">  Manage School Year
                  </Link></li>
                  {
                    getAccessLevelByModule(modEnum.BACP) ?
                      <li className='bg-color-6'><Link to="/schoolAdmin/managePackage"> Manage BC & AC Package</Link></li> :
                      null
                  }
                  <li className='bg-color-6'><Link to="/schoolAdmin/poslocation">  Manage POS Location </Link></li>
                  <li className='bg-color-6'><Link to="/schoolAdmin/nutrition">  Manage Nutrition Info </Link></li>
                  <li className='bg-color-6'><Link to="/schoolAdmin/broadcastMessage" > Broadcast Message</Link></li>
                </ul>
              </li>) : null}


            <li className='bg-color-1'><Link to="/schoolAdmin/help" name="Help" ><i className="fa fa-info-circle"></i></Link></li>
          </ul>
        </div>
      </div>
    )
  }
}
export default QuickBar;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Home/quickbar.jsx